import { api } from "..";
import { ToggleReadOnlyPayload } from "./types";
import { Chat } from "@/types/ApiResponses/Chat";

export const toggleChatReadOnly = async (
  payload: ToggleReadOnlyPayload
): Promise<Chat> => {
  const { chatId, readOnly } = payload;
  const res = await api.client.patch(`/chats/${chatId}/read-only`, { readOnly });
  return res.data;
};
